import React from 'react'
import _ from 'lodash'
import { darken } from 'polished'
import styled, { withTheme } from 'styled-components'
import Select, { components } from 'react-select'
import { FocusSensor } from 'libreact/lib/FocusSensor'
import { UpArrow, DownArrow } from './Arrow'
import Checkmark from './Checkmark'

const styles = (theme, { size }) => ({
  option: (provided) => ({
    ...provided,
    color: theme.colors.grey2,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'white',

    '&:hover': {
      color: theme.colors.grey1,
      backgroundColor: darken(0.05, theme.colors.white),
    },
  }),
  menu: (provided) => ({
    ...provided,
    maxWidth: 100,
  }),
  container: (provided) => ({
    ...provided,
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  control: (provided, state) => ({
    ...provided,
    borderRadius: '999px',
    border: state.isFocused ? theme.borders.transparent : theme.borders.grey6,
    width: '100px',
    textAlign: 'center',
    fontSize: '14px',
    minHeight: 0,
    padding: '0px 10px',
    backgroundColor: theme.colors.white,
    boxShadow: state.isFocused ? theme.boxShadow.greenLight : theme.boxShadow.greyLight,

    '&:hover': {
      border: state.isFocused ? theme.borders.transparent : theme.borders.grey5,
    },
  }),
})

const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    {props.selectProps.menuIsOpen ? <UpArrow /> : <DownArrow />}
  </components.DropdownIndicator>
)

const Option = ({ children, ...rest }) => (
  <components.Option {...rest}>
    {children} {rest.isSelected && <Checkmark />}
  </components.Option>
)

const Container = styled.div`
  display: flex;
  align-items: center;
`

const Label = styled.div`
  color: ${props => props.theme.colors.grey3};
  padding-right: 5px;
`

export default withTheme(({
  theme,
  bold,
  colorful,
  disabled,
  onClick,
  onChange,
  label,
  value,
  ...props,
}) => (
  <FocusSensor>
    {({ isFocused }) => (
      <Container onClick={onClick}>
        {label && <Label>{label}</Label>}
        <Select
          {...props}
          styles={styles(theme, props)}
          components={{ DropdownIndicator, Option }}
          value={_.find(props.options, { value })}
          isFocused={isFocused}
          isDisabled={disabled}
          isSearchable={false}
          onChange={({ value }) => {
            onClick()
            onChange({
              name: props.name,
              value,
            })
          }}
        />
      </Container>
    )}
  </FocusSensor>
))
